module.exports = __webpack_public_path__ + "static/media/photo-15.00551f13.jpg";